<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 赋码管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>生码记录查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="100px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="订单" prop="qrcode_orderno">
                <el-input v-model="searchform.qrcode_orderno" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商编码" prop="supplier_id">
                <el-input v-model="searchform.supplier_id" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="下载状态" prop="qrcode_status">
                <el-select
                  v-model="searchform.qrcode_status"
                  style="width:100%"
                  placeholder="请选择码状态"
                >
                  <el-option
                    v-for="item in qrcode_status"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="类型" prop="qrcode_order_type">
                <el-select
                  v-model="searchform.qrcode_order_type"
                  style="width:100%"
                  placeholder="请选择数据类型"
                >
                  <el-option
                    v-for="item in qrcode_order_type"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生码时间" prop="createtime">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.createtime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['records_select']"
              >搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                v-permission="['records_export']"
                :loading="downloadLoading"
                icon="document"
                type="primary"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
          </el-row>
          <br />
        </el-form>
      </div>

      <el-row type="flex" class="row-bg">
        <el-col :span="22" class="border">
          <el-divider></el-divider>
          <el-table
            border
            @cell-click="danghang"
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="id" label="编号" width="60"></el-table-column>
            <el-table-column prop="qrcode_orderno" label="订单" width="120"></el-table-column>
            <el-table-column prop="qrcode_quantity" label="生码数量" width="80"></el-table-column>
            <el-table-column prop="qrcode_status_name" label="下载状态" width="80"></el-table-column>
            <el-table-column prop="qrcode_order_type_name" label="类型" width="80"></el-table-column>
            <el-table-column prop="supplier" label="供应商" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="buildcode_time" label="生码时间"></el-table-column>
            <el-table-column prop="action" label="操作" width="110">
              <template scope="scope">
                <el-button
                  v-permission="['records_download']"
                  type="primary"
                  size="mini"
                  :loading="scope.row.qrcode_status == 4"
                  icon="document"
                  @click="download(scope.row.id,scope.row.qrcode_orderno)"
                  v-show="scope.row.qrcode_status !==3"
                  plain
                >下载</el-button>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[20,30,40,50,100,300]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { complete, downpack } from "@/api/tagging";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { setTimeout } from "timers";
import store from "@/store";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
  },
  data() {
    return {
      //基础数据
      listLoading: true,
      downloadLoadingxiazai: false,
      tableData: [],
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      qrcode_status: [
        {
          key: 2,
          label: "未下载"
        },
        {
          key: 3,
          label: "已下载"
        },
        {
          key: 4,
          label: "下载中"
        }
      ],
      qrcode_order_type: [
        {
          key: 0,
          label: "手工创建"
        },
        {
          key: 1,
          label: "接口推送"
        }
      ],
      rule_id: [
        {
          key: 0,
          label: "测试"
        }
      ],
      searchform: {
        createtime: "",
        supplier_id: "",
        product_code: "",
        qrcode_orderno: "",
        rule_id: "",
        qrcode_status: null,
        qrcode_order_type: null,
        page_index: 1,
        page_size: 20
      },
      // 下载传参
      downloadcode: false,
      id: "",
      orderNo: ""
    };
  },
  methods: {
    //请求表格数据
    tablefor() {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].buildcode_time = this.tableData[
          i
        ].buildcode_time.replace(/T/, " ");
        this.tableData[i].create_time = this.tableData[i].create_time.replace(
          /T/,
          " "
        );
        if (this.tableData[i].supplier_name !== null) {
          this.tableData[i].supplier =
            this.tableData[i].supplier_id + this.tableData[i].supplier_name;
        } else {
          this.tableData[i].supplier = this.tableData[i].supplier_id;
        }
      }
    },
    Tabledata(obj) {
      this.listLoading = true;
      complete(obj).then(response => {
        this.tableData = response.data.data;
        this.tablefor();
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    //搜索事件
    search() {
      this.Tabledata({
        page_size: this.searchform.page_size,
        supplier_id: this.searchform.supplier_id,
        create_start_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[0],
        create_end_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[1],
        product_code: this.searchform.product_code,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      });
    },
    // 单行点击
    danghang(row) {
      this.id = row.id;
      this.orderNo = row.qrcode_orderno;
      console.log(row.id);
    },
    // base64转成 blob
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    //下载二进制文件按钮
    download(id, orderNo) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // this.downloadcode = true
      downpack({ id: id, orderNo: orderNo }).then(response => {
        loading.close();
        this.Tabledata({
          page_index: this.searchform.page_index,
          page_size: this.searchform.page_size,
          supplier_id: this.searchform.supplier_id,
          create_start_time:
            this.searchform.createtime == null
              ? null
              : this.searchform.createtime[0],
          create_end_time:
            this.searchform.createtime == null
              ? null
              : this.searchform.createtime[1],
          product_code: this.searchform.product_code,
          rule_id: this.searchform.rule_id,
          qrcode_orderno: this.searchform.qrcode_orderno,
          qrcode_order_type: this.searchform.qrcode_order_type,
          qrcode_status: this.searchform.qrcode_status
        });
        // 处理返回的文件流
        const content = this.dataURLtoBlob(response.data);
        const blob = new Blob([content]);
        const fileName = response.message;
        if ("download" in document.createElement("a")) {
          // IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          // 谷歌火狐下载
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          if (window.navigator.msSaveBlob) {
            // ie下载
            console.log(window.navigator.msSaveBlob);
            try {
              window.navigator.msSaveBlob(blob, fileName);
            } catch (e) {
              console.log(e);
            }
          }
        } else {
        }
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(page_index) {
      this.searchform.page_index = page_index;
      this.Tabledata({
        page_index: this.searchform.page_index,
        page_size: this.searchform.page_size,
        supplier_id: this.searchform.supplier_id,
        create_start_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[0],
        create_end_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[1],
        product_code: this.searchform.product_code,
        rule_id: this.searchform.rule_id,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      });
    },
    //分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.page_size = page_size;
      this.search();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      complete({
        page_index: 1,
        page_size: this.total_count,
        supplier_id: this.searchform.supplier_id,
        create_start_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[0],
        create_end_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[1],
        product_code: this.searchform.product_code,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      }).then(response => {
        this.tableDataDownload = response.data.data;
        for (let i = 0; i < this.tableDataDownload.length; i++) {
          this.tableDataDownload[i].buildcode_time = this.tableDataDownload[
            i
          ].buildcode_time.replace(/T/, " ");
          this.tableDataDownload[i].create_time = this.tableDataDownload[
            i
          ].create_time.replace(/T/, " ");
          if (this.tableDataDownload[i].supplier_name !== null) {
            this.tableDataDownload[i].supplier =
              this.tableDataDownload[i].supplier_id +
              this.tableDataDownload[i].supplier_name;
          } else {
            this.tableDataDownload[i].supplier = this.tableDataDownload[
              i
            ].supplier_id;
          }
        }
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "编码",
            "订单",
            "生码数量",
            "下载状态",
            "类型",
            "供应商",
            "创建时间",
            "生码时间"
          ];
          const filterVal = [
            "id",
            "qrcode_orderno",
            "qrcode_quantity",
            "qrcode_status_name",
            "qrcode_order_type_name",
            "supplier",
            "create_time",
            "buildcode_time"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>
<style >
#parent tr {
  background-color: #ffffff;
}
#parent td {
  border-bottom: 1px solid #dfdfdf;
}
</style>